import { Component } from "@angular/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})

/** CLASSE PRINCIPAL DP ARQUIVO */
export class AppComponent {
  
  title = "Gerenciador de Tarefas";

}



// WEBPACK FOOTER //
// C:/xampp2/htdocs/angular-front/src/app/app.component.ts